import Header from './Compartido/Header.jsx';
import Footer from './Compartido/Footer.jsx';
import BtnFloating from './Compartido/BtnFloating.jsx';
import Intro from './VillaIndividual/Intro.jsx';
import PanelInferior from './VillaIndividual/PanelInferior.jsx';
import Content from './VillaIndividual/Content.jsx';
import Map from './VillaIndividual/Map.jsx';
import Scripts from './Compartido/Scripts.jsx';

import '../../../../../resources/css/web/holidayhomescanarias/header.css'
import '../../../../../resources/css/web/holidayhomescanarias/buscador.css'
import '../../../../../resources/css/web/holidayhomescanarias/footer.css'
import '../../../../../resources/css/web/holidayhomescanarias/general.css'
import '../../../../../resources/css/web/holidayhomescanarias/rooms.css'
import '../../../../../resources/css/web/holidayhomescanarias/intro.css'
import '../../../../../resources/css/web/holidayhomescanarias/swiper.min.css'
import '../../../../../resources/css/web/holidayhomescanarias/villa-individual.css'
import '../../../../../resources/css/web/holidayhomescanarias/buttons.css'

const VillaIndividual = (props) => {
    return (
        <main>
            <Header
                datos={props.websgrupo}
                lang={props.lang}
                idiomas={props.idiomas}
                tipo="inicio"
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
            />
            <Intro
                lang={props.lang}
                ruta={props.ruta}
                propiedad={props.propiedad}
            />
            <PanelInferior
                lang={props.lang}
                propiedad={props.propiedad}
            />
            <Content
                lang={props.lang}
                propiedad={props.propiedad}
                servicios={props.servicios}
                ruta={props.ruta}
                diasbloqueados={props.diasbloqueados}
                primerdialibre={props.primerdialibre}
                calendario={props.calendario}
                politicas={props.politicas}
                preciominimo={props.preciominimo}
                llegada={props.llegada}
                salida={props.salida}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                mascotas={props.mascotas}
                configweb={props.websgrupo}
                moneda={props.moneda}
                destino={props.eldestino}
                diasbloqueadossolos={props.diasbloqueadossolos}
                diasbloqueadoscal={props.diasbloqueadoscal}
            />
            <Map
                lang={props.lang}
                propiedad={props.propiedad}
            />
            <Footer
                lang={props.lang}
                config={props.config}
            />
            <BtnFloating />

            <Scripts />
        </main>
    );
}

export default VillaIndividual;

